import { Skeleton } from "@/components/ui/skeleton";
import { TableCell, TableRow } from "@/components/ui/table";
import { cn } from "@/utils";

const SKELETON_ROWS = [
  { categoryWidth: "w-40", id: "ticket-a", titleWidth: "w-3/4" },
  { categoryWidth: "w-32", id: "ticket-b", titleWidth: "w-2/3" },
  { categoryWidth: "w-44", id: "ticket-c", titleWidth: "w-4/5" },
  { categoryWidth: "w-28", id: "ticket-d", titleWidth: "w-1/2" },
  { categoryWidth: "w-40", id: "ticket-e", titleWidth: "w-3/5" },
  { categoryWidth: "w-32", id: "ticket-f", titleWidth: "w-3/4" },
  { categoryWidth: "w-44", id: "ticket-g", titleWidth: "w-2/3" },
  { categoryWidth: "w-28", id: "ticket-h", titleWidth: "w-4/5" },
] as const;

/** 独立与嵌入工单列表共用原有骨架行，表头由实际列定义负责。 */
export function TicketListSkeletonRows() {
  return (
    <>
      {SKELETON_ROWS.map((row) => (
        <TableRow className="bg-card hover:bg-card" key={row.id}>
          <TableCell className="w-10 pl-4">
            <Skeleton className="size-4 rounded-sm" />
          </TableCell>
          <TableCell className="min-w-0 py-3 pl-2">
            <div className="flex min-w-0 items-center gap-3">
              <Skeleton className="size-4 shrink-0 rounded-sm" />
              <div className="min-w-0 flex-1">
                <Skeleton className={cn("h-4", row.titleWidth)} />
                <div className="mt-1 flex items-center gap-3">
                  <Skeleton className="h-5 w-14 rounded-sm" />
                  <Skeleton className="h-3 w-20" />
                  <Skeleton className="h-5 w-20 rounded-sm" />
                  <Skeleton className="h-3 w-8" />
                  <Skeleton className="h-3 w-28" />
                </div>
              </div>
            </div>
          </TableCell>
          <TableCell className="hidden xl:table-cell">
            <Skeleton className={cn("h-4", row.categoryWidth)} />
          </TableCell>
          <TableCell className="hidden md:table-cell">
            <div className="flex items-center gap-2">
              <Skeleton className="size-6 shrink-0 rounded-full" />
              <Skeleton className="h-4 w-24" />
            </div>
          </TableCell>
          <TableCell className="hidden xl:table-cell">
            <Skeleton className="h-4 w-24" />
          </TableCell>
          <TableCell className="pr-3">
            <Skeleton className="ml-auto size-7 rounded-md" />
          </TableCell>
        </TableRow>
      ))}
    </>
  );
}
